import type { UseFormRegister } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Typography } from '@/components';
import { t } from 'i18next';
import { ChangeEvent } from 'react';

interface SizeSectionProps {
  value: [string, string];
  onChange: (value: [string, string]) => void;
  unit: string;
  fromRegistration: ReturnType<UseFormRegister<any>>;
  toRegistration: ReturnType<UseFormRegister<any>>;
  isCompanyForm?: boolean;
}

export function SizeSection({ value, onChange, unit, fromRegistration, toRegistration, isCompanyForm }: SizeSectionProps) {
  const handleIntegerInput = (e: ChangeEvent<HTMLInputElement>, index: 0 | 1) => {
    const inputValue = e.target.value;
    if (inputValue === '' || /^\d+$/.test(inputValue)) {
      const newValue: [string, string] = [...value];
      newValue[index] = inputValue;
      onChange(newValue);
    }
  };

  return (
    <div className="space-y-2">
      {isCompanyForm ? (
        <div className="mb-4 space-y-0.5">
          <Typography as="h4" color="primary" size="body-2" weight="semibold">
            {t('Size')}
          </Typography>
        </div>
      ) : (
        <div className="space-y-0.5">
          <Typography as="h4" color="primary" size="title" weight="semibold">
            {t('What project size are you looking for?')}
          </Typography>
          <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1">
            {t('You can select more than one option')}
          </Typography>
        </div>
      )}
      <div className="flex flex-col gap-3 md:flex-row md:gap-6">
        <div className="flex flex-1 items-center gap-2">
          <Typography as="span" size="body-2" weight="semibold" className="truncate" color="primary-accent">
            Minimum Size
          </Typography>
          <Input
            type="number"
            min="0"
            step="1"
            {...fromRegistration}
            value={value[0]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleIntegerInput(e, 0)}
            onKeyDown={(e) => {
              if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            }}
            className="flex-1 rounded-xl border px-3 py-2 text-center text-sm font-semibold transition-all focus:ring-2 focus:ring-offset-2 md:text-base"
            style={{
              borderColor: '#279D59',
              backgroundColor: 'white',
            }}
            placeholder="0"
          />
          <Typography as="span" size="body-2" weight="semibold" className="truncate" color="primary-accent">
            {unit}
          </Typography>
        </div>
        <div className="flex flex-1 items-center gap-2">
          <Typography as="span" size="body-2" weight="semibold" className="truncate" color="primary-accent">
            Maximum size
          </Typography>
          <Input
            type="number"
            min="0"
            step="1"
            {...toRegistration}
            value={value[1]}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleIntegerInput(e, 1)}
            onKeyDown={(e) => {
              if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            }}
            className="flex-1 rounded-xl border px-3 py-2 text-center text-sm font-semibold transition-all focus:ring-2 focus:ring-offset-2 md:text-base"
            style={{
              borderColor: '#279D59',
              backgroundColor: 'white',
            }}
            placeholder="0"
          />
          <Typography as="span" size="body-2" weight="semibold" className="truncate" color="primary-accent">
            {unit}
          </Typography>
        </div>
      </div>
    </div>
  );
}
